// https://github.com/tc39/proposal-observable
require('../internals/define-well-known-symbol')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/esnext.symbol.observable.js
// module id = 297
// module chunks = 1